import { Borders, Row, Workbook, Worksheet } from "exceljs"
import { PersonalList } from "../../types"

type ExportExcel = {
  data: PersonalList[]
  companyName?: string
}

export const exportExcel = async ({ data }: ExportExcel) => {
  const workbook = new Workbook()
  const worksheet = workbook.addWorksheet("Sheet 1")
  const columns = [
    "NO",
    "ID",
    "NAME",
    "COUNTRY",
    "PROVINCE",
    "REGENCY",
    "DEPARTMENT",
    "DIVISI",
    "BANK"
  ]
  worksheet.views = [{ showGridLines: false }]

  // Title
  makeTitle(worksheet)

  // Header
  const headers = worksheet.addRow(columns)
  headers.font = { bold: true, color: { argb: 'FFFFFFFF' } }
  headers.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF000000" }
    }
    cell.border = {
      top: { style: "thin", color: { argb: "000000" } },
      left: { style: "thin", color: { argb: "000000" } },
      bottom: { style: "thin", color: { argb: "000000" } },
      right: { style: "thin", color: { argb: "000000" } }
    }
  })

  makeRows(data, worksheet)

  // create xlsx
  await workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    })
    const url = URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = "register-employee.xlsx"
    a.click()
    URL.revokeObjectURL(url)
  })
}

function makeTitle(worksheet: Worksheet) {
  // Baris pertama: judul utama
  worksheet.mergeCells(1, 1, 1, 9);
  const mainTitle = worksheet.getCell(1, 1);
  mainTitle.value = "CARDS";
  mainTitle.font = { bold: true, size: 15 };
  mainTitle.alignment = {
    vertical: "middle",
    horizontal: "center",
  };

  // Baris kedua: sub-judul
  worksheet.mergeCells(2, 1, 2, 9);
  const subTitle = worksheet.getCell(2, 1);
  subTitle.value = "REGISTER EMPLOYEE";
  subTitle.font = { bold: true, size: 15 };
  subTitle.alignment = {
    vertical: "middle",
    horizontal: "center",
    wrapText: true,
  };

  worksheet.getRow(1).height = 25;
  worksheet.getRow(2).height = 20;
  worksheet.getColumn(2).width = 20;
}


function makeRows(data: ExportExcel["data"], worksheet: Worksheet) {
  let itemRow: Row

  const cellBorder: Partial<Borders> = {
    top: { style: "thin", color: { argb: "000000" } },
    left: { style: "thin", color: { argb: "000000" } },
    bottom: { style: "thin", color: { argb: "000000" } },
    right: { style: "thin", color: { argb: "000000" } }
  }

  data.forEach((item, index) => {
    itemRow = worksheet.addRow([
      index + 1,
      item.employee_code,
      item.employee_name,
      item.country_name ?? "-",
      item.province_name ?? "-",
      item.regency_name ?? "-",
      item.department_name ?? "-",
      item.divisi_name ?? "-",
      item.bank_name ?? "-"
    ])

    itemRow.eachCell((cell) => {
      cell.border = cellBorder
    })
  })
}
